/**
 * Csv Schema of AuditoriaTransfolha
 * @author Simpli CLI generator
 */
import {Helper, Schema, FieldSet} from 'simpli-web-sdk'
import {AuditoriaTransfolha} from '@/model/resource/AuditoriaTransfolha'

/* TODO: review generated schema */
export class CsvAuditoriaTransfolhaSchema extends Schema {
  readonly name = 'CsvAuditoriaTransfolha'

  readonly fieldSet: FieldSet<AuditoriaTransfolha> = {
    idAuditoria: schema => schema.model.idAuditoria,
    lote: schema => schema.model.lote,
    json: schema => schema.model.json,
    dataCriacao: schema => Helper.datetime(schema.model.dataCriacao),
    reprocessar: schema => Helper.bool(schema.model.reprocessar),
  }
}
